import styled from "styled-components";
import {media} from "../../../theme/responsive.js";
import {White, LightSlate, Teal} from "../../../theme/variable";
import FooterSprite from "../../../images/Footer-sprite.svg";
import InstagramIcon from "../../../images/instagram.svg";
import InstagramHoverIcon from "../../../images/instagram_hover.svg";
import AircLogo from "../../../images/AIRC-Logo.png";

export const FooterSection = styled.div`
    width: 100%;
    background: #2a2a2a;
    color: ${White};
    text-align: center;
    position: relative;
    padding-bottom: ${(props) =>
        props.dashboardBottomHeight ? props.dashboardBottomHeight + "px" : ""};
    ${media.laptop` padding-bottom: unset`}
`;
export const FooterUpperSection = styled.div`
    background: ${White};
    border-radius: 10px;
    padding: 10px;
    width: auto;
    margin: 16px;
    display: inline-block;
    ${media.laptop` width: 714px;margin: 18px auto;`}
`;
export const FooterMiddleSection = styled.div`
    padding: 16px 16px 0 16px;
    color: ${White};
    display: flex;
    flex-direction: column;
    background: #4d4d4d;
    & > div:first-child {
        border-top: none;
        padding-top: unset;
        ${media.laptop`padding-top:unset; border-top:unset`}
    }
    ${media.laptop`padding: 44px 120px;flex-direction: row;`}
`;
export const FooterInfoSection = styled.div`
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #a6a6a6;
    margin-bottom: 10px;
    padding-bottom: 10px;
    &:first-child {
        padding-top: 8px;
        border-top: 1px solid #a6a6a6;
        ${media.laptop`padding-top:unset; border-top:unset;`}
    }
    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
    ${media.laptop`width: 20%;margin-bottom:0; padding-bottom:0; border-bottom:none;`}
`;
export const FooterDetailSection = styled.div`
    width: 100%;
    text-align: left;
    margin-bottom: 10px;
    display: ${(props) => (props.aircStyle ? "flex" : "")};
    justify-content: ${(props) => (props.aircStyle ? "space-between" : "")};
    & a:last-child {
        color: ${White};
        font-size: 0.75rem;
        text-align: center;
        width: 130px;
        & span {
            margin-top: 4px;
            display: block;
        }
    }
    ${media.laptop`width: 20%;margin-bottom:0; display:unset`}
`;
export const FooterSectionLabel = styled.label`
    display: block;
    font-size: 0.875rem;
    color: ${White};
    font-weight: 600;
    padding: 6px 0;
    position: relative;
    ${media.laptop`padding:0;`}
`;

export const FooterSectionList = styled.div`
    width: 100%;
    max-height: ${(props) => (props.accordionClass === "active" ? "20em" : "0")};
    overflow: ${(props) => (props.overflowUnset ? "unset" : "hidden")};
    display: block;
    transition: all 0.5s ease-in-out;
    ${media.laptop`max-height:unset;overflow:inherit`}
    ul {
        margin-top: 10px;
        li {
            list-style: none;
            margin-bottom: 8px;
            width: 49%;
            display: inline-block;
            position: relative;
            ${media.laptop`width: 100%;display:block;`}
            a {
                color: #a6a6a6;
                font-size: 0.75rem;
                line-height: 16px;
                vertical-align: middle;
                &:hover {
                    color: ${White};
                }
            }
        }
        li.aircLogo {
            display: none;
            ${media.laptop`display:block`}
        }
        li.aircLogo:before {
            content: "";
            background: url(${AircLogo});
            display: block;
            width: 64px;
            height: 64px;
            background-position: center center;
        }
        li.aircLogo a {
            // margin-left: 18px;
            margin-top: 7px;
            width: 130px;
        }
    }
`;
export const FooterBottomSection = styled.div`
    background: #4d4d4d;
    padding: 8px 16px 16px;
    color: ${White};
    display: flex;
    flex-direction: column;
    ${media.laptop`padding: 44px 120px;flex-direction: row;background: #2a2a2a;`}
`;
export const FooterBottomInfoSection = styled.div`
    display: flex;
    padding: 16px 16px;
    flex-direction: column;
    align-items: flex-end;
    ${media.laptop`padding: 24px 120px;flex-direction: row;`}
`;
export const FooterInfoGreySection = styled.div`
    background: rgba(255, 255, 255, 0.2);
    border-radius: 23px;
    color: ${White};
    padding: 4px 10px;
    display: inline-block;
    margin-top: 9px;
    font-size: 0.75rem;
    &:hover {
        background: rgba(255, 255, 255, 0.4);
    }
    && a,
    && a:hover {
        color: ${White};
        width: unset;
    }
`;
export const FooterNaukriCompany = styled.div`
    color: ${White};
    font-size: 0.75rem;
    i {
        background: url(${FooterSprite});
        display: inline-block;
        width: 104px;
        height: 16px;
        background-position: -182px -124px;
        vertical-align: middle;
    }
`;
export const FooterLastBottomSection = styled.div`
    background: #121212;
    font-size: 0.75rem;
    color: #999;
    display: flex;
    flex-direction: column;
    padding: 16px;
    justify-content: space-between;
    text-align: left;
    line-height: 16px;
    ${media.laptop`padding: 10px 120px;flex-direction: row;`}
    ul {
        li {
            display: inline-block;
            vertical-align: middle;
            &:last-child {
                &:after {
                    content: none;
                }
            }
            &:after {
                display: inline-block;
                content: "";
                width: 4px;
                height: 4px;
                background: #999;
                border-radius: 50%;
                margin: 0 8px;
                vertical-align: middle;
            }
        }
    }
`;
export const FooterLastBottomLeftPart = styled.div`
    display: inline-flex;
    margin-bottom: 10px;
    && a {
        color: ${LightSlate};
    }
    && a:hover {
        color: ${White};
    }
    ${media.laptop`margin-bottom: 0px;`}
`;
export const FooterLastBottomRightPart = styled.div`
    display: inline-flex;
`;
export const NewTag = styled.div`   
    font-style: normal;
    background: #2F80ED;
    padding: 4px 16px 3px 6px;
    border-radius: 2px;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    line-height: 10px;
    position: relative;
    overflow: hidden;
    margin-left: 16px;
    display:inline-block;
    vertical-align:middle;
    &:after{
        content: "";
        display: inline-block;
        width: 0px;
        height: 0px;
        border: 6px solid #2a2a2a;
        position: absolute;
        right: -6px;
        top: 3px;
        transform: rotate(45deg);
    }
}`;
export const FooterLogo = styled.div`
    background: url(${FooterSprite});
    display: inline-block;
    width: 171px;
    height: 65px;
    background-position: -7px 0;
`;
export const MailIcon = styled.i`
    background: url(${FooterSprite});
    display: inline-block;
    width: 20px;
    height: 16px;
    background-position: -202px -100px;
    vertical-align: middle;
`;
export const WriteReviewIcon = styled(MailIcon)`
    background-position: -182px -100px;
`;
export const FooterSocialLinks = styled.div`
    display: inline-flex;
    & a:last-child {
        width: unset;
        & i {
            margin-top: 1px;
            margin-right: 0;
        }
    }
    ${media.laptop`display:unset`}
`;
export const FooterFacebookDiv = styled.div``;
export const FooterFBIcon = styled(MailIcon)`
    width: 26px;
    height: 28px;
    background-position: -183px -11px;
    margin-top: 3px;
    margin-right: 4px;
    &:hover {
        background-position: -183px -41px;
    }
`;
export const FooterYouTubeIcon = styled(FooterFBIcon)`
    background-position: -210px -11px;
    &:hover {
        background-position: -210px -41px;
    }
`;
export const FooterInstagramIcon = styled.i`
    background: url(${InstagramIcon}) no-repeat;
    background-position: 0 0;
    width: 28px;
    height: 28px;
    margin-top: 3px;
    margin-right: 4px;
    display: inline-block;
    position: relative;
    top: 6px;
    margin-left: 4px;
    &:hover {
        background: url(${InstagramHoverIcon}) no-repeat;
        background-position: 0 0;
    }
`;
export const ScrollToTopLink = styled.div`
    position: absolute;
    bottom: 60px;
    right: 48px;
`;
export const ScrollToTopIcon = styled.i`
    background: url(${FooterSprite});
    display: inline-block;
    width: 46px;
    height: 48px;
    background-position: -275px -7px;
    vertical-align: middle;
    &:hover {
        background-position: -275px -53px;
    }
`;
export const ScrollToTopSection = styled.span`
    color: ${White};
    background: #2a2a2a;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 15px 0 12px;
    text-align: center;
    position: relative;
    text-transform: uppercase;
    display:block;
    &:before {
        content: "";
        background: url(${FooterSprite});
        display: inline-block;
        width: 12px;
        height: 9px;
        background-position: -249px -84px;
        position: absolute;
        top: 6px;
        left: 49%;
`;
export const ArrowUpDownIcon = styled.i`
    background: url(${FooterSprite});
    display: inline-block;
    width: 12px;
    height: 9px;
    background-position: -226px -84px;
    position: absolute;
    right: ${(props) => (props.accordionClass ? "5px" : "8px")};
    top: ${(props) => (props.accordionClass ? "7px" : "12px")};
    transform: ${(props) => (props.accordionClass ? "rotate(180deg)" : "")};
`;
export const EnquiryDownIcon = styled(ArrowUpDownIcon)`
    right: 0px;
    top: 7px;
    cursor: pointer;
    ${media.laptop`right: 41px;`}
`;
export const FooterContributeFollowUsSection = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 10px;
`;
export const EnquiryTooltipSection = styled.div`
    position: relative;
`;
export const EnquiryTooltip = styled.div`
    background: ${White};
    color: #666;
    font-size: 0.75rem;
    border-radius: 8px;
    padding: 10px;
    width: 180px;
    position: absolute;
    top: 25px;
    right: -19px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
    transition: all 0.5s ease-in-out;

    ${media.laptop`right: -48px;`}
    &:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid #fff;
        position: absolute;
        top: -5px;
        left: 45%;
    }
    && a,
    && a:hover {
        color: ${Teal};
    }
`;
export const FooterSearchDiv = styled.div`
    padding: 16px 16px 8px 16px;
    background: #4d4d4d;
    p {
        background: #fff;
        color: #666;
        padding: 10px;
        text-align: left;
        border-radius:4px;
        font-size:0.75rem;
        span{
            display:inline-block;
            width:90%;
        }
        }
    }
`;
export const FooterSearchIcon = styled.i`
    background: url(${FooterSprite});
    display: inline-block;
    width: 27px;
    height: 16px;
    background-position: -235px -99px;
    vertical-align: middle;
`;

export const AIRCLogo = styled.i`
    content: "";
    background: url(${AircLogo});
    display: inline-block;
    width: 64px;
    height: 64px;
    background-position: center center;
`;
